import { render, staticRenderFns } from "./PrtMaterialDetail.vue?vue&type=template&id=5cf57654&scoped=true"
import script from "./PrtMaterialDetail.vue?vue&type=script&lang=js"
export * from "./PrtMaterialDetail.vue?vue&type=script&lang=js"
import style0 from "./PrtMaterialDetail.vue?vue&type=style&index=0&id=5cf57654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf57654",
  null
  
)

export default component.exports